<template>
  <div class="text-sm" :class="{ 'sm:text-xs': navbarMode }" v-if="cart.activeCoupons.length > 1">
    <div class="w-full bg-gray-200 rounded-full h-4 border-2 border-gray-200">
      <div class="bg-emerald-500 rounded-full h-full" :style="`width: ${completedWidth}%`"></div>
    </div>
    <div class="mt-4 text-left font-bold text-sm" :class="navbarMode ? 'sm:text-sm' : 'sm:text-md'">
      <span v-if="cart.subtotal.dollars < activeSaleCoupon.minimumCartAmount">
        {{ remainingValueForDiscount | formatDollars }} Away From
        <span class="uppercase text-emerald-500">{{ activeSaleCoupon.percentage | discountLabel }}</span> Your Cart
      </span>
      <span v-else>
        You earned <span class="uppercase text-emerald-500">{{ activeSaleCoupon.percentage | discountLabel }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cart.DiscountProgressBar",
  props: {
    cart: {
      required: true,
      type: Object,
    },
    navbarMode: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    completedWidth() {
      return (
        (Math.min(this.cart.subtotal.dollars, this.activeSaleCoupon.minimumCartAmount) * 100) /
        this.activeSaleCoupon.minimumCartAmount
      )
    },
    remainingValueForDiscount() {
      return this.activeSaleCoupon.minimumCartAmount - this.cart.subtotal.dollars
    },
    activeSaleCoupon() {
      return this.cart.activeCoupons.slice(-1)[0]
    },
  },
}
</script>
